import { UniversalPickerMode } from "../types";
import { FileLogStatus } from "shared/types/file";

export const SEARCH_PLACEHOLDERS: Record<UniversalPickerMode, string> = {
  "helpdesk-label": "Zoek label...",
  "file-label": "Zoek label...",
  "secondary-file-label": "Zoek secundair label...",
  assignee: "Zoek verantwoordelijke...",
  building: "Zoek gebouw...",
  unit: "Zoek unit...",
  supplier: "Zoek leverancier...",
  reporter: "Zoek melder (naam of email)...",
  source: "Zoek bron...",
  status: "Zoek status...",
  "rental-contract": "Zoek huurcontract...",
  "document-date": "",
  "expiration-date": "",
  "custom-tags": "Zoek tag...",
  "text-input": "Zoek tekst...",
  "number-input": "Zoek nummer...",
  asset: "Zoek asset...",
  "bug-priority": "Zoek prioriteit...",
  "bug-type": "Zoek type...",
  "bug-status": "Zoek status...",
  epic: "Zoek epic...",
  "renovation-project": "Zoek renovatieproject...",
  "project-part": "Zoek projectonderdeel...",
  "helpdesk-status": "Zoek ticket fase",
  "acquisition-file": "Zoek acquisitiedossier...",
  resource: "Zoek contact of bedrijf...",
  room: "Zoek ruimte...",
};

export const SECONDARY_FILE_LABELS = [
  "Commercieel",
  "Technisch",
  "Juridisch",
  "Financieel",
  "Administratief",
  "Onderhoud",
  "Renovatie",
  "Schoonmaak",
];

export const STATUS_OPTIONS = [
  { label: "Onbekend", value: FileLogStatus.UNKNOWN },
  { label: "OK", value: FileLogStatus.OK },
  { label: "Niet OK", value: FileLogStatus.NOT_OK },
  { label: "OK met opmerkingen", value: FileLogStatus.OK_WITH_REMARKS },
  { label: "Niet vereist", value: FileLogStatus.NOT_REQUIRED },
];

export const REMOVAL_LABELS: Record<string, string> = {
  supplier: "Leverancier verwijderen",
  reporter: "Melder verwijderen",
  assignee: "Toewijzing verwijderen",
  resource: "Relatie verwijderen",
  unit: "Geen unit",
  "project-part": "Onderdeel verwijderen",
  "renovation-project": "Project verwijderen",
  building: "Geen gebouw",
  room: "Geen ruimte",
  default: "Verwijderen",
};
